<template>
  <section class="team-grid" :style="section.config.style">
    <div class="container">
      <div class="section-title">
        <h2>{{ section.config.title }}</h2>
        <p>{{ section.config.subtitle }}</p>
      </div>
      
      <div class="team-members" :class="[`layout-${section.config.layout}`]">
        <div v-for="member in section.config.members" :key="member.id" class="member-card">
          <div class="member-avatar">{{ member.avatar }}</div>
          <h3 class="member-name">{{ member.name }}</h3>
          <p class="member-position">{{ member.position }}</p>
          <p class="member-description">{{ member.description }}</p>
          <div v-if="section.config.showSocial && member.social" class="member-social">
            <a v-for="(link, platform) in member.social" :key="platform" :href="link" class="social-link">
              {{ platform === 'email' ? '✉️' : platform === 'linkedin' ? '💼' : platform === 'github' ? '💻' : '🐦' }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TeamGrid',
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.team-grid {
  padding: 80px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.section-title {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 0.5rem;
}

.section-title p {
  font-size: 1.125rem;
  color: var(--gray-600);
}

.team-members {
  display: grid;
  gap: 2rem;
}

.layout-grid {
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

.member-card {
  background: white;
  padding: 2.5rem 2rem;
  border-radius: var(--radius-xl);
  text-align: center;
  box-shadow: var(--shadow);
  transition: all 0.3s ease;
  border: 1px solid var(--gray-200);
}

.member-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-xl);
}

.member-avatar {
  font-size: 4rem;
  margin-bottom: 1.5rem;
  width: 5rem;
  height: 5rem;
  background: var(--gradient-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  color: white;
}

.member-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: 0.5rem;
}

.member-position {
  font-size: 1rem;
  color: var(--primary-color);
  margin-bottom: 1rem;
  font-weight: 500;
}

.member-description {
  font-size: 0.875rem;
  color: var(--gray-600);
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.member-social {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: var(--gray-100);
  border-radius: 50%;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: var(--primary-color);
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .layout-grid {
    grid-template-columns: 1fr;
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/sections/TeamGrid.vue